import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Delay showing banner slightly for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setShowBanner(false);
    // Enable Google AdSense after consent
    if (window.adsbygoogle) {
      window.adsbygoogle.requestNonPersonalizedAds = 0;
    }
  };

  const declineCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setShowBanner(false);
    // Request non-personalized ads only
    if (window.adsbygoogle) {
      window.adsbygoogle.requestNonPersonalizedAds = 1;
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-slate-200 shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1 pr-4">
            <h3 className="font-semibold text-slate-800 mb-1">Utilizamos cookies</h3>
            <p className="text-sm text-slate-600">
              Este site utiliza cookies para melhorar sua experiência e exibir anúncios personalizados. 
              Ao clicar em "Aceitar", você concorda com nossa{' '}
              <a href="/privacidade" className="text-emerald-600 hover:underline">Política de Privacidade</a>
              {' '}e{' '}
              <a href="/termos" className="text-emerald-600 hover:underline">Termos de Uso</a>.
            </p>
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={declineCookies}
              className="flex-1 sm:flex-none"
            >
              Recusar
            </Button>
            <Button
              size="sm"
              onClick={acceptCookies}
              className="flex-1 sm:flex-none bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              Aceitar Cookies
            </Button>
          </div>
          <button
            onClick={declineCookies}
            className="absolute top-2 right-2 sm:static text-slate-400 hover:text-slate-600 p-1"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
